export const DASHBOARD_MODAL_CLOSED = 'DASHBOARD_MODAL_CLOSED';
export const DASHBOARD_MODAL_OPENED = 'DASHBOARD_MODAL_OPENED';
export const DASHBOARD_MODAL_LOADED = 'DASHBOARD_MODAL_LOADED';
export const DASHBOARD_MODAL_LOADING = 'DASHBOARD_MODAL_LOADING';
